// extracted by mini-css-extract-plugin
module.exports = {"message":"ValidationMessage_message__HLC5U"};